import { createElement, type ReactNode } from "react";
import type { Product } from "@/types/catalog";
import { ProductCard } from "./ProductCard";

type ProductGridProps = {
  products: Product[];
  promoSlot?: ReactNode;
  promoIndex?: number;
  showSwatches?: boolean;
};

export function ProductGrid({
  products,
  promoSlot,
  promoIndex = 3,
  showSwatches = false,
}: ProductGridProps) {
  const items: ReactNode[] = [];

  products.forEach((product, index) => {
    if (promoSlot && index === promoIndex) {
      items.push(createElement("div", { key: "promo-slot" }, promoSlot));
    }
    items.push(
      <ProductCard key={product.id} product={product} showSwatches={showSwatches} />,
    );
  });

  if (promoSlot && products.length <= promoIndex) {
    items.push(createElement("div", { key: "promo-slot-end" }, promoSlot));
  }

  return createElement(
    "div",
    { id: "product-grid", className: "kmart-product-grid" },
    items,
  );
}
